export default __webpack_public_path__ + "static/grouped-column-182429b21113de9c6550773be7693060.png";